<template>
    <Page header="Верификация" type="" :nopadding="false" header_pos="center">
        <template #body>
            <div class="flex flex-row w-full justify-content-center mb-5">
                <div class="flex flex-column gap-4 w-full max-w-30rem">
                    <!-- Шаг 0: проверка статуса KYC -->
                    <div v-if="step===0" class="flex flex-column w-full gap-3">
                        <span class="flex text-md font-medium">Проверка статуса отправителя</span>

                        <div class="flex flex-column gap-2 p-3 border-1 surface-border border-round-xl">
                            <div class="flex flex-row justify-content-between">
                                <span class="text-600">Имя</span>
                                <span class="text-900">{{ client.first_name }}</span>
                            </div>
                            <div class="flex flex-row justify-content-between">
                                <span class="text-600">Фамилия</span>
                                <span class="text-900">{{ client.last_name }}</span>
                            </div>
                            <div class="flex flex-row justify-content-between">
                                <span class="text-600">Email</span>
                                <span class="text-900">{{ client.email }}</span>
                            </div>
                            <div class="flex flex-row justify-content-between">
                                <span class="text-600">Телефон</span>
                                <span class="text-900">{{ client.phone }}</span>
                            </div>
                            <!-- <Divider/>
                            <div class="flex flex-row justify-content-between">
                                <span class="text-600">Фото паспорта</span>
                                <span class="text-900" :class="(selectedDocumentId) ? 'text-green-600' : 'text-red-600'">
                                    {{ (selectedDocumentId) ? 'ок' : 'не загружен' }}
                                </span>
                            </div>
                            <div class="flex flex-row justify-content-between">
                                <span class="text-600">Фото лица</span>
                                <span class="text-900" :class="(selectedFaceId) ? 'text-green-600' : 'text-red-600'">
                                    {{ (selectedFaceId) ? 'ок' : 'не загружен' }}
                                </span>
                            </div> -->
                        </div>
                        <div v-if="client.kyc" class="flex flex-column gap-2 p-3 border-1 surface-border border-round-lg">
                            <div class="flex flex-row gap-2 align-items-center">
                                <span class="flex">Статус: </span> 
                                <Tag :severity="getKycSeverity(client.kyc.status)" class="text-xs">
                                    {{ getKycStatus(client.kyc.status) }}
                                </Tag>
                            </div>
                            <div class="flex flex-row gap-2 align-items-center">
                                <span class="flex">Сообщение: </span> 
                                <Message v-if="client.kyc.last_message" size="small" class="flex border-0"
                                    :severity="isRejected ? 'error' : 'info'" 
                                    :icon="isRejected ? 'pi pi-exclamation-triangle' : 'pi pi-info-circle'">
                                    {{ client.kyc.last_message }}
                                </Message>
                            </div>
                        </div>
                        <div v-if="isRejected" class="flex justify-content-between gap-2">
                           <Button label="Начать верификацию" icon="pi pi-arrow-right" class="flex w-full border-round-xl flex-1" severity="info" iconPos="right"
                                @click='step=1'/>
                        </div>
                        <div v-else class="flex justify-content-between gap-2">
                           <Button label="На главную" icon="pi pi-arrow-right" class="flex w-full border-round-xl flex-1 border-0" severity="success" iconPos="right"
                                @click='goToMain()'/>
                        </div>
                    </div>

                    <!-- Шаг 1: основные данные -->
                    <div v-if="step===1" class="flex flex-column w-full gap-3">
                
                        <div class="flex flex-column w-full gap-2">
                            <span class="flex">Полное имя: </span>
                            <InputText v-model="client.first_name" class="flex border-2 border-round-lg border-300" placeholder="Иван" @blur="v$.client.first_name.$touch()" />
                            <small v-if="v$.client.first_name.$error" class="text-red-500">Укажите имя</small>
                        </div>

                        <div class="flex flex-column w-full gap-2">
                            <span class="flex">Фамилия: </span>
                            <InputText v-model="client.last_name" class="flex border-2 border-round-lg border-300" placeholder="Иванов" @blur="v$.client.last_name.$touch()" />
                            <small v-if="v$.client.last_name.$error" class="text-red-500">Укажите фамилию</small>
                        </div>

                        <div class="flex flex-column w-full gap-2">
                            <span class="flex">Email: </span>
                            <InputText v-model="client.email" class="flex border-2 border-round-lg border-300" placeholder="ivan@example.com" @blur="v$.client.email.$touch()" />
                            <small v-if="v$.client.email.$error" class="text-red-500">Введите корректный email</small>
                        </div>

                        <div class="flex flex-column w-full gap-2">
                            <span class="flex">Номер телефона: </span>
                            <InputText v-model="client.phone" class="flex border-2 border-round-lg border-300" placeholder="79998887766" :useGrouping="false" @blur="v$.client.phone.$touch()" />
                            <small v-if="v$.client.phone.$error" class="text-red-500">Введите телефон (10–15 цифр)</small>
                        </div>

                        <div class="w-full flex mt-2 flex justify-content-between flex-wrap gap-3">
                            <Button label="Продолжить" @click='step=2'
                                class="flex w-full border-round-lg" :loading="loading" :disabled="loading || !isFormValid" severity="info" />
                        </div>
                    </div>

                    <!-- Шаг 2: документ -->
                    <div v-if="step===2" class="flex flex-column w-full gap-3">
                        <span class="flex text-md font-medium">Загрузите фото документа</span> 
                        <div v-if="filesDocument.length>0" class="flex w-full gap-2">
                            <div v-for="file in filesDocument" :key="file.id"
                                class="flex flex-column gap-2 p-2 border-1 surface-border border-round-lg w-6rem">
                                <div class="flex flex-column">
                                    <img :src="file.url" v-if="file.url && (file.mimetype=='image/png' || file.mimetype=='image/jpg' || file.mimetype=='image/jpeg')"
                                        class="w-full border-1 surface-border border-round-lg mt-2" />
                                </div>
                                <div class="flex flex-row align-items-start gap-2">
                                    <RadioButton :inputId="'doc-'+file.id" :value="file.id" v-model="selectedDocumentId" :checked="selectedDocumentId === file.id" />
                                </div>
                            </div>
                        </div>
                        <UploadFilesPublic :multiple="false" :maxFiles="1" :data="{ client_id: clientId, from: 'user', type: 'document' }"
                            @onUpload="files => onUpload(files, 'document')" @onReset="() => resetFiles('document')" @onLoading="setLoading" />
                        <div class="flex justify-content-between gap-2">
                            <Button label="Назад" @click="step=1" :disabled="loading" 
                                class="flex border-round-lg" severity="info" outlined />
                            <Button label="Продолжить" @click="step=3" :disabled="!selectedDocumentId || loading"
                                class="flex w-full border-round-lg flex-1" severity="info" />
                        </div>
                    </div>

                    <!-- Шаг 3: лицо -->
                    <div v-if="step===3" class="flex flex-column w-full gap-3">
                        <span class="flex text-md font-medium">Загрузите фото с лицом</span>
                        <div v-if="filesFace.length>0" class="flex w-full gap-2">
                            <div v-for="file in filesFace" :key="file.id"
                                class="flex flex-column gap-2 p-2 border-1 surface-border border-round-lg w-6rem">
                                <div class="flex flex-column">
                                    <img :src="file.url" v-if="file.url && (file.mimetype=='image/png' || file.mimetype=='image/jpg' || file.mimetype=='image/jpeg')"
                                        class="w-full border-1 surface-border border-round-lg mt-2" />
                                </div>
                                <div class="flex flex-row align-items-start gap-2">
                                    <RadioButton :inputId="'face-'+file.id" :value="file.id" v-model="selectedFaceId" />
                                </div>
                            </div>
                        </div>
                        <UploadFilesPublic :multiple="false" :maxFiles="1" :data="{ client_id: clientId, from: 'user', type: 'face' }"
                            @onUpload="files => onUpload(files, 'face')" @onReset="() => resetFiles('face')" @onLoading="setLoading"
                            :userLogin="userLogin" />
                        <div class="flex justify-content-between gap-2">
                            <Button label="Назад" @click="step=2" :disabled="loading" 
                                class="flex border-round-lg" severity="info" outlined />
                            <Button label="Продолжить" @click="goNextFromFace()" :disabled="!selectedFaceId || loading"
                                class="flex w-full border-round-lg flex-1" severity="info" />
                        </div>
                    </div>

                    <!-- Шаг 4: отправка на KYC -->
                    <div v-if="step===4" class="flex flex-column w-full gap-3">
                        <Message severity="success" size="small" icon="pi pi-send">Проверьте данные перед отправкой</Message>
                        <div class="flex flex-column gap-2 p-3 border-1 surface-border border-round-lg">
                            <div class="flex flex-row justify-content-between">
                                <span class="text-600">Имя</span>
                                <span class="text-900">{{ client.first_name }}</span>
                            </div>
                            <div class="flex flex-row justify-content-between">
                                <span class="text-600">Фамилия</span>
                                <span class="text-900">{{ client.last_name }}</span>
                            </div>
                            <div class="flex flex-row justify-content-between">
                                <span class="text-600">Email</span>
                                <span class="text-900">{{ client.email }}</span>
                            </div>
                            <div class="flex flex-row justify-content-between">
                                <span class="text-600">Телефон</span>
                                <span class="text-900">{{ client.phone }}</span>
                            </div>
                            <Divider/>
                            <div class="flex flex-row justify-content-between">
                                <span class="text-600">Фото паспорта</span>
                                <span class="text-900">{{ (selectedDocumentId) ? 'ок' : 'не загружен' }}</span>
                            </div>
                            <div class="flex flex-row justify-content-between">
                                <span class="text-600">Фото лица</span>
                                <span class="text-900">{{ (selectedFaceId) ? 'ок' : 'не загружен' }}</span>
                            </div>
                        </div>
                        <div class="flex justify-content-between gap-2">
                            <Button label="Редактировать" @click="step=1" :disabled="loading" class="flex border-round-lg" severity="secondary" outlined/>
                            <Button label="Отправить" icon="pi pi-arrow-right" class="flex w-full border-round-xl flex-1 border-0" severity="success" iconPos="right"
                                @click='SendToKYC()' :loading="loading" :disabled="loading || !selectedDocumentId || !selectedFaceId" />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Page>

    <Dialog v-model:visible="dialog" modal class="border-none">
        <template #header>
            <div class="flex flex-column w-full mb-3">
                <span class="flex text-lg font-medium">Информация по KYC</span>
            </div>
        </template>
        <KycInfo />
    </Dialog> 
</template>

<script>
import Connect from '@/assets/js/Connect.js'
import Helper from '@/assets/js/Helper.js'
import UploadFilesPublic from '@/components/widgets/UploadFiles.vue'
import { useVuelidate } from '@vuelidate/core'
import { required, email, helpers } from '@vuelidate/validators'
import Page from '@/components/sides/Page.vue'
import KycInfo from '@/components/widgets/kyc_info.vue'

export default {
    props: {
        sender_id: { type: Number, default: null },
        first_name: { type: String, default: '' },
        last_name: { type: String, default: '' },
        middle_name: { type: String, default: '' },
        email: { type: String, default: '' },
        phone: { type: String, default: '' },
        kyc: { type: Object, default: () => ({}) },
        files: { type: Array, default: () => [] }
    },
    components: { 
        UploadFilesPublic, 
        Page, 
        KycInfo 
    },
    setup() {
        return { v$: useVuelidate() }
    },
    data() {
        return {
            full_files: [],
            step: null,
            loading: false,
            dialog: false,
            clientId: null,
            client: {
                user_login: null,
                id: null,
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                files: []
            },
            selectedDocumentId: null,
            selectedFaceId: null,
            userLogin: null,
            kycStatus: null,
            steps: [
                {
                    label: 'Статус',
                    value: 0
                },
                {
                    label: 'Контакты',
                    value: 1
                },
                {
                    label: 'Паспорт',
                    value: 2
                },
                {
                    label: 'Фото',
                    value: 3
                },
                {
                    label: 'Прописка',
                    value: 4
                },
                {
                    label: 'KYC',
                    value: 5
                }
            ],
            $confirm: {
                require: {
                    header: 'Подтвердите действие',
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: 'Да',
                    rejectLabel: 'Нет',
                    acceptButtonStyleClass: 'p-button-danger',
                }
            }
        }
    },
    validations() {
        const isPhone = helpers.withMessage(
            'Введите телефон (10–15 цифр)',
            value => /^[0-9]{10,15}$/.test(String(value ?? ''))
        )
        return {
            client: {
                user_login: {},
                id: {},
                first_name: { required },
                last_name: { required },
                email: { required, email },
                phone: { required, isPhone },
                files: {}
            }
        }
    },
    computed: {
        // filesDocument() { return this.full_files.filter(f => f.type === 'document' || !f.type) },
        // filesFace() { return this.full_files.filter(f => f.type === 'face' || !f.type) },

        filesDocument() { return this.full_files.filter(f => f) },
        filesFace() { return this.full_files.filter(f => f) },

        isFormValid() {
            return !this.v$.$invalid
        },
        isRejected(){
            return this.client.kyc && this.client.kyc.status && (this.client.kyc.status=='rejected') ? true : false
        },
    },
    watch: {
        first_name(newVal) {
            this.client.first_name = newVal
        },
        last_name(newVal) {
            this.client.last_name = newVal
        },
        email(newVal) {
            this.client.email = newVal
        },
        phone(newVal) {
            this.client.phone = newVal
        },
        kyc(newVal) {
            this.client.kyc = newVal
        },
        files(newVal) {
            this.client.files = newVal
            this.GetPersonalFiles()
        },
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({severity, summary, detail, life: 5000});
        },
        openConfirm(){
            this.$confirm.require({
                message: 'Сбросить и начать сначала?',
                header: 'Подтвердите действие',
                icon: 'pi pi-exclamation-triangle',
                rejectProps: {
                    label: 'Нет',
                    severity: 'secondary',
                    outlined: true
                },
                acceptProps: {
                    label: 'Да',
                    severity: 'info'
                },
                accept: () => {
                    this.ResetData()
                },
                reject: () => {}
            })
        },
        goNextFromFace(){
            this.step = 4
        },
        getKycStatus(status){
            return this.helper.getKycStatus(status)
        },
        goToMain(){
            this.$router.push({path: '/'})
        },
        getKycSeverity(status){
            return this.helper.getKycSeverity(status)
        },
        async GetPersonalFiles() {
            if(!this.files || this.files.length === 0) return
            try {
                const resFiles = await this.connect.GetPersonalFilesByIds(this.files).then(res=>res)
                if(resFiles && resFiles.result && Array.isArray(resFiles.data)){
                    // Если тип отсутствует, оставляем как есть; отобразим файл на шагах с фильтром по типу или без типа
                    this.full_files = resFiles.data.map(f => ({ ...f }))
                }
            } catch(e) { }
        },
        onUpload(files, fileType){
            if(!files || files.length===0) return
            for (let i = 0; i < files.length; i++) {
                const f = files[i]
                const id = (f.id) ? f.id : f._id ? f._id : null
                if(id){
                    const newF = { ...f, type: fileType }
                    this.full_files.push(newF)
                    if(fileType==='document') this.selectedDocumentId = id
                    if(fileType==='face') this.selectedFaceId = id
                    
                } else {
                    this.showMess('error', 'Ошибка', 'Загруженный файл не содержит идентификатор')
                }
            }
        },
        resetFiles(fileType){
            this.files = this.files.filter(f => f.type !== fileType)
            if(fileType==='document') this.selectedDocumentId = null
            if(fileType==='face') this.selectedFaceId = null
        },
        setLoading(val){ this.loading = val },
        async SendToKYC(){
            if (!this.selectedDocumentId || !this.selectedFaceId) {
                this.showMess('error', 'Ошибка', 'Выберите файл документа и файл с лицом')
                return
            }
            const dataSender = {
                id: this.sender_id,
                first_name: this.client.first_name,
                last_name: this.client.last_name,
                email: this.client.email,
                phone: this.client.phone,
                files: [this.selectedDocumentId, this.selectedFaceId]
            }
            this.loading = true
            try{
                const send = await this.connect.AddPersonalSender(dataSender).then(res => res)
                if(send.result && send.data){
                    this.showMess('success', 'Успешно', 'Верификация отправлена')
                    this.step = 0
                } else {
                    if(send.message){
                        this.showMess('error', 'Ошибка', send.message)
                    } else {
                        this.showMess('error', 'Ошибка', 'Не удалось отправить на KYC')
                    }
                }
            } catch(e){
                this.showMess('error', 'Ошибка', 'Ошибка при отправке на KYC')
                console.log('error', e)
            }
            this.loading = false
        },
        async CheckKycStatus(){
            if(!this.clientId){
                this.kycStatus = 'not_sent'
                return
            }
            if(!this.userLogin){
                return
            }
            const data = {
                client_id: this.clientId,
                user_login: this.userLogin
            }
            try {
                const res = await this.connect.PublicKycStatus(data).then(res=>res)
                if(res && res.result){
                    this.kycStatus = res.data.status
                } else {
                    this.kycStatus = res?.message || 'Не удалось получить статус'
                }
            } catch(e){
                this.kycStatus = 'not_sent'
            }
        },
        async ResetData(){
            this.step = 1
            this.clientId = null
            this.client = {
                user_login: this.userLogin || null,
                id: null,
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                files: []
            }
            this.files = []
            this.selectedDocumentId = null
            this.selectedFaceId = null
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted(){
        // Перепроверяем валидацию телефона после автозаполнения
        if (this.v$ && this.v$.client && this.v$.client.phone) {
            this.v$.client.phone.$touch();
            this.v$.client.phone.$validate();
        }
        if(this.sender_id) this.step=0
        else this.step=1
    }
}
</script>